import { apiGateway } from '../api';

async function dadosMovimentacaoPendente(numSequencialMovimentacao) {
    try {
        const response = await apiGateway.get(`/movimentacoes/pendentes/${numSequencialMovimentacao}`);
        return response.data;
    } catch (error) {
        return error.response;
    }
}

async function dadosMovimentacaoHistorico(numSequencialMovimentacao) {
    try {
        const response = await apiGateway.get(`/movimentacoes/historico/${numSequencialMovimentacao}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export { dadosMovimentacaoPendente, dadosMovimentacaoHistorico };
